import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@klickdata/core/auth';
import { Media } from '@klickdata/core/media/src/media.model';
import { MediaService } from '@klickdata/core/media/src/media.service';
import { MessageService } from '@klickdata/core/message/src/message.service';
import { User } from '@klickdata/core/user';
import { Utils } from '@klickdata/core/util';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { BehaviorSubject, map, Observable, takeUntil } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MediaType } from '@klickdata/core/media/src/media-type';
@Component({
    selector: 'app-dialog-video-player',
    templateUrl: './dialog-video-player.component.html',
    styleUrls: ['./dialog-video-player.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogVideoPlayerComponent extends OnDestroyHandler implements OnInit {
    public media$: Observable<Media>;
    public isVideoUrl$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public urlSource: FormControl = new FormControl(null);
    MediaType = MediaType;
    constructor(
        protected dialogRef: MatDialogRef<DialogVideoPlayerComponent>,
        @Inject(MAT_DIALOG_DATA) protected data: { id: number; autoplay?: boolean },
        protected mediaService: MediaService,
        protected messageService: MessageService,
        protected cd: ChangeDetectorRef,
        protected authService: AuthService
    ) {
        super();
    }

    ngOnInit(): void {
        const mediaId = this.data.id;
        if (mediaId) {
            this.media$ = this.mediaService.getMedia(+mediaId, 'large', 'author,tags,user_feeds').pipe(
                map((media: Media) => {
                    // Configure autoplay and hide controls for video
                    if (media) {
                        if (
                            !!Utils.isVideoUrl(media.url || media.src || media.link) &&
                            media.mediaType !== MediaType.AUDIO
                        ) {
                            this.urlSource.patchValue(media.url || media.src || media.link, { emitEvent: false });
                            this.isVideoUrl$.next(true);
                        }
                        console.log(media);
                        if (media.mediaType === MediaType.VIDEO) {
                            // Set playerOptions for Plyr (non-HTML5 videos)
                            media.playerOptions = {
                                ...media.playerOptions,
                                autoplay: true,
                                muted: false,
                                controls: [], // Empty array hides all controls
                                clickToPlay: false, // Disable click to play
                            };
                        }
                    }
                    return media;
                }),
                takeUntil(this.destroy)
            );
        }
    }
}
